import React from "react";

const TicketNo = ({ onSelectTicket }) => {
  const image = "/images/bubble.png"; // Single image for all tickets
  const ticketNumbers = Array.from({ length: 10 }, (_, index) => index); // Ticket numbers 0-9

  return (
    <div className="flex items-center justify-center">
      {/* Grid layout for displaying tickets in 5 columns */}
      <div className="grid grid-cols-5 gap-4">
        {ticketNumbers.map((ticketNumber) => (
          <div
            key={ticketNumber}
            className="relative flex items-center justify-center rounded-full bg-gray-200 cursor-pointer"
            style={{ width: "55px", height: "55px" }} // Same size for all tickets
            onClick={() => onSelectTicket(ticketNumber)} // Pass ticket number
          >
            {/* Display ticket background image */}
            <img
              src={image}
              alt={`Ticket ${ticketNumber}`}
              className="w-full h-auto object-cover rounded-full"
            />

            {/* Ticket number overlay on the image */}
            <span
              className="absolute text-center font-bold text-black" // Black ticket number text
              style={{
                fontSize: "24px",
              }}
            >
              {ticketNumber}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TicketNo;
